import React from 'react'
import PropTypes from 'prop-types'

const DownloadStatusWaitingIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 60 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2246 30.2702V4.2666C24.2246 3.38296 24.941 2.66663 25.8246 2.66663C26.7083 2.66663 27.4246 3.38296 27.4246 4.2666V30.2702L33.2265 24.4683C33.8513 23.8434 34.8643 23.8434 35.4892 24.4683C36.114 25.0931 36.114 26.1062 35.4892 26.731L26.956 35.2642C26.3311 35.889 25.3181 35.889 24.6933 35.2642L16.16 26.731C15.5352 26.1062 15.5352 25.0931 16.16 24.4683C16.7849 23.8434 17.7979 23.8434 18.4227 24.4683L24.2246 30.2702ZM5.0249 36.2661C5.0249 35.3825 5.74124 34.6662 6.62488 34.6662C7.50852 34.6662 8.22486 35.3825 8.22486 36.2661V42.6661C8.22486 44.1388 9.41875 45.3327 10.8915 45.3327H40.7577C42.2305 45.3327 43.4244 44.1388 43.4244 42.6661V36.2661C43.4244 35.3825 44.1407 34.6662 45.0243 34.6662C45.908 34.6662 46.6243 35.3825 46.6243 36.2661V42.6661C46.6243 45.9061 43.9978 48.5326 40.7577 48.5326H10.8915C7.65146 48.5326 5.0249 45.9061 5.0249 42.6661V36.2661Z"
      fill="#4A4A4A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.7749 63.0001C52.6115 63.0001 59.7749 55.8366 59.7749 47.0001C59.7749 38.1635 52.6115 31.0001 43.7749 31.0001C34.9383 31.0001 27.7749 38.1635 27.7749 47.0001C27.7749 55.8366 34.9383 63.0001 43.7749 63.0001Z"
      fill="#FEF7E9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.7747 58.6459C37.3429 58.6459 32.1289 53.4319 32.1289 47.0001C32.1289 40.5682 37.3429 35.3542 43.7747 35.3542C50.2066 35.3542 55.4206 40.5682 55.4206 47.0001C55.4206 53.4319 50.2066 58.6459 43.7747 58.6459ZM43.7747 57.0209C49.3091 57.0209 53.7956 52.5344 53.7956 47.0001C53.7956 41.4657 49.3091 36.9792 43.7747 36.9792C38.2404 36.9792 33.7539 41.4657 33.7539 47.0001C33.7539 52.5344 38.2404 57.0209 43.7747 57.0209ZM43.7747 39.6875C44.2235 39.6875 44.5872 40.0513 44.5872 40.5V46.6635L47.5993 49.6755C47.9166 49.9928 47.9166 50.5073 47.5993 50.8246C47.282 51.1419 46.7675 51.1419 46.4502 50.8246L43.2002 47.5746C43.0478 47.4222 42.9622 47.2155 42.9622 47V40.5C42.9622 40.0513 43.326 39.6875 43.7747 39.6875Z"
      fill="white"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="32"
      y="35"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.7747 58.6459C37.3429 58.6459 32.1289 53.4319 32.1289 47.0001C32.1289 40.5682 37.3429 35.3542 43.7747 35.3542C50.2066 35.3542 55.4206 40.5682 55.4206 47.0001C55.4206 53.4319 50.2066 58.6459 43.7747 58.6459ZM43.7747 57.0209C49.3091 57.0209 53.7956 52.5344 53.7956 47.0001C53.7956 41.4657 49.3091 36.9792 43.7747 36.9792C38.2404 36.9792 33.7539 41.4657 33.7539 47.0001C33.7539 52.5344 38.2404 57.0209 43.7747 57.0209ZM43.7747 39.6875C44.2235 39.6875 44.5872 40.0513 44.5872 40.5V46.6635L47.5993 49.6755C47.9166 49.9928 47.9166 50.5073 47.5993 50.8246C47.282 51.1419 46.7675 51.1419 46.4502 50.8246L43.2002 47.5746C43.0478 47.4222 42.9622 47.2155 42.9622 47V40.5C42.9622 40.0513 43.326 39.6875 43.7747 39.6875Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect x="30.0859" y="34.0001" width="26" height="26" fill="#F9AF27" />
    </g>
  </svg>
)

DownloadStatusWaitingIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

DownloadStatusWaitingIcon.defaultProps = {
  width: 60,
  height: 63,
}

export default DownloadStatusWaitingIcon
